// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import App from './App'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
// import { getData } from '@/api/local_storage'

window.ECharts = require('echarts')

sync(store, router)

Vue.use(ElementUI)

// store.dispatch('setLoginData', {data: getData('loginInfo'), save: false})
// store.dispatch('login')

Vue.config.productionTip = false

/* eslint-disable no-new */
window.myvm = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js